module.exports = __webpack_public_path__ + "b801ef8c6dc1a0c67f00a8c92101752a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/video_play_triangle.svg
// module id = 214
// module chunks = 0